"use client";

import { ClaimResult } from "@/utils/contract-errors";
import { useState } from "react";
import Modal from "../Modal";
import StakeScreen from "./StakeScreen";
import ClaimedScreen from "./ClaimedScreen";

interface IProps {
  close: () => void;
  isOpen: boolean;
  allocatedSpon: number;
  onClaim: () => Promise<ClaimResult>;
  onVestedClaim: () => Promise<ClaimResult>;
  onStake: () => Promise<boolean>;
  isStaking: boolean;
  isVestedClaim: boolean;
}

const ClaimTokensModal = ({
  close: _close,
  isOpen,
  allocatedSpon,
  onClaim,
  onVestedClaim,
  onStake,
  isStaking,
  isVestedClaim,
}: IProps) => {
  const [screen, setScreen] = useState<"stake" | "claimed">("stake");
  const [claimedAmount] = useState(allocatedSpon);

  const close = () => {
    setScreen("stake");
    _close();
  };

  return (
    <Modal close={close} isOpen={isOpen} className="w-[90%] md:w-[660px]">
      <div className="flex flex-col gap-y-9">
        <div className="flex flex-col gap-y-8">
          {
            {
              stake: (
                <StakeScreen
                  onNext={() => setScreen("claimed")}
                  allocatedSpon={allocatedSpon}
                  onClaim={onClaim}
                  onVestedClaim={onVestedClaim}
                  onStake={onStake}
                  isStaking={isStaking}
                  isVestedClaim={isVestedClaim}
                  onCancel={() => close()}
                />
              ),
              claimed: (
                <ClaimedScreen
                  onNext={() => close()}
                  allocatedSpon={claimedAmount}
                />
              ),
            }[screen]
          }
        </div>
      </div>
    </Modal>
  );
};

export default ClaimTokensModal;
